// Grouping config for the Access Control UI (frontend-only presentation layer).
// Mirrors the sidebar's 7 visible categories so admins recognise the structure
// when editing staff permissions. Admin-only system controls (User Management,
// Access Control, Manage Accounts, Bulk Import, Staff Credentials, System Logs,
// Build Reports) are intentionally absent — those stay locked to Admin role
// and must never be assignable as staff permissions.
export const UI_MODULE_GROUPS = [
  {
    key: 'today',
    label: 'Today',
    description: 'Daily entry surfaces',
    modules: ['dashboard', 'focus_hub'],
  },
  {
    key: 'athletes-teams',
    label: 'Athletes & Teams',
    description: 'Athlete identity, squads, tags, team state, media',
    modules: ['athletes', 'athlete_tags', 'team_state', 'media_highlights'],
  },
  {
    key: 'performance',
    label: 'Performance',
    description: 'Training, matches, reports, assessments, alerts',
    modules: [
      'training',
      'attendance',
      'attendance.finalize',
      'attendance.reopen',
      'training_programs',
      // Phase 75 — granular submodules inside Training Programs. They are
      // rendered as indented children of the `training_programs` row.
      'training_programs.snc',
      'training_programs.nutrition',
      'training_programs.football',
      'matches',
      'match_reports',
      'fitness_assessment',
      'pdp',
      'alerts_flags',
      'alert_rules',
    ],
  },
  {
    key: 'insights-analytics',
    label: 'Insights & Analytics',
    description: 'Read-only analytical and decision-support tools',
    modules: [
      'decision_engine',
      'squad_analytics',
      'academy_overview',
      'season_reports',
      // Phase 87 — Trial Reports + its independent Export action (rendered as
      // an indented child row by EditAccessSheet's generic child handling).
      'trial_reports',
      'trial_reports.export',
      'compare_seasons',
      'compare_athletes',
    ],
  },
  {
    key: 'player-health',
    label: 'Player Health',
    description: 'Daily monitoring, injury, biometrics, wellness, mental',
    modules: [
      'daily_monitoring',
      'injury_recovery',
      'biometrics',
      'wellness',
      'mental_hub',
    ],
  },
  {
    key: 'development',
    label: 'Development',
    description: 'Long-term growth — academic and career pathway',
    modules: ['academic', 'career_pathway'],
  },
  {
    key: 'operations',
    label: 'Operations',
    description: 'Shared operational tools — finance, documents, comms, seasons',
    modules: ['finance', 'documents', 'announcements', 'seasons'],
  },
];

export const PERMISSION_LEVELS = ['none', 'view', 'edit', 'delete'];

export const PERMISSION_META = {
  none: {
    label: 'None',
    color: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
    activeColor: 'bg-gray-200 text-gray-900 dark:bg-gray-700 dark:text-gray-100',
    tooltip: 'No access at all',
  },
  view: {
    label: 'View',
    color: 'bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300',
    activeColor: 'bg-blue-500 text-white',
    tooltip: 'Read-only access',
  },
  edit: {
    label: 'Edit',
    color: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300',
    activeColor: 'bg-emerald-500 text-white',
    tooltip: 'Create & modify records',
  },
  delete: {
    label: 'Delete',
    color: 'bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-300',
    activeColor: 'bg-red-500 text-white',
    tooltip: 'Full control including deletion',
  },
};

export const PERMISSION_RANK = { none: 0, view: 1, edit: 2, delete: 3 };
